import React, {useEffect} from "react";
import {observer} from "mobx-react-lite";

import Menu from "../Menu";


const BottomMenu = ({open, onClose}) => {

    useEffect(() => {
        if (!open) return;

        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                onClose();
            }
        };

        document.addEventListener("keydown", handleKeyDown);

        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [open, onClose]);


    if (!open) {
        return null;
    }

    return (
        <>
            <button
                type="button"
                className="menu-backdrop"
                aria-label="Close menu"
                onClick={onClose}
            />

            <aside
                className="bottom-menu"
                role="dialog"
                aria-modal="true"
                aria-label="Navigation menu"
            >
                <Menu
                    screen="mobile"
                    onClose={onClose}
                />
            </aside>
        </>
    );
};


export default observer(BottomMenu);